// deps
import React, { ReactElement } from "react";

// internal-deps
import { WalletApiFetchState } from "@swiggy-private/payment-core";
import { format } from "@swiggy-private/core-ui";

// interfaces
import { WalletData } from "@payment-ui/interfaces";

// helpers
import { isWalletLinkedMobileNoDiffrentFromUserMobileNo, isWalletTokenExpired } from "@payment-ui/helpers/Wallet";

// widgets
import Alert from "@payment-ui/widgets/alert/Alert";

// constants
import { TEXTS } from "@payment-ui/constants/index";

import styles from "../Wallet.v4.scss";

interface AlertMsgProps {
    state: WalletApiFetchState;
    walletData: WalletData;
    dataTestId?: string;
    userMobileNumber: string;
    isPayTmMethodWithLessBalance: boolean;
}

export const AlertMsg = React.memo(function WalletAlertMsg(props: AlertMsgProps): ReactElement | null {
    const { state, walletData, dataTestId, userMobileNumber, isPayTmMethodWithLessBalance } = props;
    const hasLessBalance = state === WalletApiFetchState.LOADING ? false : !walletData.isWalletBalanceSufficent;
    const isTokenExpired = state === WalletApiFetchState.LOADING ? false : isWalletTokenExpired(walletData.linkStatus);
    const isUserMobileNoDifferentFromWalletLinkedMobileNo =
        state === WalletApiFetchState.LOADING
            ? false
            : isWalletLinkedMobileNoDiffrentFromUserMobileNo(walletData.mobileNumber, userMobileNumber);

    // Show low balance message for PayTM in case of insufficient balance
    if (isPayTmMethodWithLessBalance) {
        return (
            <Alert
                className={styles.paymentMethodTokenExpired}
                message={format(TEXTS.LOW_BALANCE_DETAIL, String(walletData.additionalBalanceRequired))}
                data-testid={dataTestId}
            />
        );
    }

    if (isUserMobileNoDifferentFromWalletLinkedMobileNo) {
        return (
            <div className={styles.walletMobileNumber} data-testid={dataTestId}>
                {walletData.mobileNumber}
            </div>
        );
    }

    if (isTokenExpired) {
        return (
            <Alert
                className={styles.paymentMethodTokenExpired}
                message={TEXTS.TOKEN_EXPIRED_LINK_ACCOUNT}
                data-testid={dataTestId}
            />
        );
    }

    if (hasLessBalance) {
        return (
            <Alert
                className={styles.paymentMethodTokenExpired}
                message={format(TEXTS.LOW_BALANCE_DETAIL, String(walletData.additionalBalanceRequired))}
                data-testid={dataTestId}
            />
        );
    }

    return null;
});
